var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileySad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M10.5996 11C10.336 10.5441 9.95717 10.1656 9.50104 9.90244C9.04492 9.63928 8.52759 9.50074 8.00099 9.50073C7.47439 9.50073 6.95706 9.63926 6.50093 9.90241C6.0448 10.1656 5.66593 10.5441 5.40234 11",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M5.75 7.25C6.02614 7.25 6.25 7.02614 6.25 6.75C6.25 6.47386 6.02614 6.25 5.75 6.25C5.47386 6.25 5.25 6.47386 5.25 6.75C5.25 7.02614 5.47386 7.25 5.75 7.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M10.25 7.25C10.5261 7.25 10.75 7.02614 10.75 6.75C10.75 6.47386 10.5261 6.25 10.25 6.25C9.97386 6.25 9.75 6.47386 9.75 6.75C9.75 7.02614 9.97386 7.25 10.25 7.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileySad);
export default __webpack_public_path__ + "static/media/smileySad.85b205e43cdd548538bfa9bd2b3c5269.svg";
export { ForwardRef as ReactComponent };